import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Select, MenuItem } from '@dsi/react-eds';

interface ReleaseSelectorProps {
  anchors: string[];
  selectedAnchor: string | null;
  onSelect: (anchor: string) => void;
  disabled?: boolean;
  loading?: boolean;
}

const ReleaseSelector: React.FC<ReleaseSelectorProps> = ({ anchors, selectedAnchor, onSelect, disabled = false, loading = false }) => {
  if (loading) {
    return (
      <div className="nii-release-select">
        <label>Release Name</label>
        <ReactEDSWrapper component={Select} label="Select a release" value="" disabled>
          <ReactEDSWrapper component={MenuItem} value="">
            Loading releases...
          </ReactEDSWrapper>
        </ReactEDSWrapper>
      </div>
    );
  }

  return (
    <div className="nii-release-select">
      <label>Release Name</label>
      <ReactEDSWrapper
        component={Select}
        type="input-single"
        label="Select or type..."
        value={selectedAnchor || ''}
        disabled={disabled}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(raw: any) => {
          const next = raw?.target?.value ?? raw;
          const selected = Array.isArray(next) ? next[0] : next;
          onSelect(typeof selected === 'string' ? selected : String(selected ?? ''));
        }}
      >
        {anchors.map((anchor) => (
          <ReactEDSWrapper key={anchor} component={MenuItem} value={anchor}>
            {anchor}
          </ReactEDSWrapper>
        ))}
      </ReactEDSWrapper>
    </div>
  );
};

export default ReleaseSelector;
